"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
function trimLeft(str) {
    return str.replace(/(^\s*)/g, "");
}

function trimRight(str) {
    return str.replace(/(\s*$)/g, "");
}

function trim(str) {
    return str.replace(/(^\s*)|(\s*$)/g, "");
}

function toJson(str) {
    return new Function("return " + str)();
}

exports.default = {
    trimLeft: trimLeft,
    trimRight: trimRight,
    trim: trim,
    toJson: toJson
};
module.exports = exports["default"];